module.exports = __webpack_public_path__ + "img/watzmannnordgipfel.f445cd22.jpg";